var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": _vm.link
    }
  }, [_c('button', {
    staticClass: "custom-button",
    style: _vm.buttonStyle,
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._v(" " + _vm._s(_vm.text) + " ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }